export const hexToRGB = (hex: string): [number, number, number] => {
    const hexNormalized = hex[0] === '#' ? hex.slice(1) : hex;
    const rgbBase16 = hexNormalized.match(/.{2}/g) || [];
    const [r, g, b] = rgbBase16.map((n) => parseInt(n, 16));
    return [r, g, b];
};
